
import {catchError, map} from 'rxjs/operators';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

import { Login } from './../_models/login';
import { AlterarSenha } from './../_models/alterar-senha';
import { UsuarioLogado } from './../_models/usuariologado';
import { ValidationResult } from './../_models/validation-result';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {
    public getPasswordResetUrl(): string {
        return this.baseService.getPasswordResetUrl();
    }

    configInfo: any;

    constructor(private baseService: BaseService) {
    }

    emitirLogin = new EventEmitter<boolean>();

    login(login: Login): Observable<ValidationResult> {
        return this.baseService.Post('account',{ username: login.username, password: login.password }).pipe(
            map((response: ValidationResult) => {
                // login successful if there's a jwt token in the response
                let retorno: ValidationResult = response;
                this.baseService.limpaStorage();
                //validar se está expirado mas é vlaido
                if(retorno.Message == "")
                {
                    if (retorno.IsValid) {
                        this.baseService.setUsuarioLogado(retorno.Data as UsuarioLogado);
                        this.emitirLogin.emit(false);
                    }
                    else {
                        this.emitirLogin.emit(false);
                    }
                }
                return retorno;
            }),
            catchError(e => {
                return this.baseService.handleError(e);
            }),);
        ;
    }

    LoginForgeRock(retorno : any): Observable<ValidationResult> {
        const accessToken = retorno?.accessToken || retorno?.access_token || retorno?.token;
        const forgeRockHeaders = accessToken ? {
            Authorization: `Bearer ${accessToken}`
        } : undefined;

        return this.baseService.Post("account/loginforgerock", { username: retorno.userEmail, password: "" }, forgeRockHeaders).pipe(
            map((response: ValidationResult) => {
                let retorno: ValidationResult = response;
                this.baseService.limpaStorage();
                //validar se está expirado mas é vlaido
                if(retorno.Message == "")
                {
                    if (retorno.IsValid) {
                        const sessionId = retorno.Data?.sessionId;
                        if (sessionId)
                            sessionStorage.setItem('sessionId', sessionId);
                        this.baseService.setUsuarioLogado(retorno.Data as UsuarioLogado);
                        this.emitirLogin.emit(false);
                    }
                    else {
                        this.emitirLogin.emit(false);
                    }
                }
                return retorno;
            }),
            catchError(error => {
                return this.baseService.handleError(error);
            })
        )
    }

    logout(callModal = false): void {
        sessionStorage.removeItem('sessionId');
        this.baseService.setUsuarioLogado(null);
        this.baseService.limpaStorage();
        this.emitirLogin.emit(callModal);
    }

    emitirModal = new EventEmitter<boolean>();

    public showModal(): void {
        this.emitirModal.emit(true);
    }

    public hideModal(): void {
        this.emitirModal.emit(false);
    }

    ResetSenha(email: string): Observable<ValidationResult> {
        return this.baseService.Post('account/resetsenha', { email: email }).pipe(
        map((response: ValidationResult) => {
            let retorno: ValidationResult = response;
            return retorno;
        }),catchError(e => {
            return this.baseService.handleError(e);
        }),);
    }

    CadastrarSenha(viewmodel: AlterarSenha): Observable<ValidationResult> {
        return this.baseService.Post('account/cadastrarsenha', viewmodel).pipe(
        map((response: ValidationResult) => {
            let retorno: ValidationResult = response;
            return retorno;
        }),catchError(e => {
            return this.baseService.handleError(e);
        }),);
    }

    ObterEmail(viewmodel: AlterarSenha): Observable<ValidationResult> {
        return this.baseService.Post('account/email', viewmodel).pipe(
        map((response: ValidationResult) => {
            let retorno: ValidationResult = response;
            return retorno;
        }),catchError(e => {
            return this.baseService.handleError(e);
        }),);
    }

    GetUltimasAlteracoesSenha():Observable<ValidationResult> {
      return this.baseService.Get('account/ultimasaltercoessenha').pipe(
        map((response: ValidationResult) => {
            let retorno: ValidationResult = response;
            return retorno;
        }),catchError(e => {
            return this.baseService.handleError(e);
        }),);
    }

}
